// 추후 AppEnum.palette.Shape 를 여기에 병합시켜야 함.

import { Vector2d } from './types'

export enum CANVAS_HANDLE_MODE {
  DEFAULT, // PAN, ZOOM 조작이 가능한 상태
  DRAW, // PAN이 막히고, 그리기만 가능한 상태 ( ZOOM은 테스트 해봐야 함 )
  EDIT, // PAN만 막힌 상태
  CREATE, // 도형 생성 모드
  SELECTION, // 번호 풍선을 정렬하기 위해 번호 풍선 선택 모드
  AUTO_ALIGN, // 자동 정렬 모드 (shape 선택 불가)
  DIRECTION_DRAW, // ARROW 도형 그리기 전용 모드
}

export enum CANVAS_STATE {
  IDLE, // 기본 상태
  DRAWING, // 그리기 중
  DRAGGING, // 드래깅 중
  ZOOMING, // 줌 중
}

export enum CANVAS_FOCUS_MODE {
  SINGLE,
  MULTIPLE,
}

export enum CANVAS_CREATE_METHOD {
  DRAG = 'DRAG',
  DRAG_AND_DROP = 'DRAG_AND_DROP',
  MOUSE_UP = 'MOUSE_UP',
}

export enum SHAPES {
  POINT = 'POINT',
  DIRECTION = 'DIRECTION', // 방향을 나타내는 화살표 도형
  TRIPOD = 'TRIPOD', // 삼발이 도형 (3개 포인트를 결합한 형태)
  RECT = 'RECT',
  ELLIPSE = 'ELLIPSE',
  LINE = 'LINE',
  ARROW = 'ARROW',
  DOUBLE_ARROW = 'DOUBLE_ARROW',
  BRUSH = 'BRUSH',
}

export enum CANVAS_ENTITY_CLASS_NAME {
  READONLY = 'readonly', // 읽기 전용 클래스 : Selection이 불가능하며 시스템만 제어 가능함.
}

export enum CANVAS_HANDLE_EVENT {
  // stage 이벤트를 초기화 할 때, 끝이 _system 인경우는 제외하므로 주의해서 작성
  SYSTEM_PANNING_STAGE_MOUSE_OUT = 'mouseout.panning_system',
  SYSTEM_PANNING_STAGE_MOUSE_UP = 'mouseup.panning_system',
  SYSTEM_PANNING_STAGE_MOUSE_DOWN = 'mousedown.panning_system',
  SYSTEM_PANNING_STAGE_MOUSE_LEAVE = 'mouseleave.panning_system',

  SYSTEM_PANNING_STAGE_TOUCH_START = 'touchstart.panning_system',
  SYSTEM_PANNING_STAGE_TOUCH_MOVE = 'touchmove.panning_system',
  SYSTEM_PANNING_STAGE_TOUCH_END = 'touchend.panning_system',

  SYSTEM_VIEWPORT_CHANGED_DRAGMOVE = 'dragmove.system',
  SYSTEM_VIEWPORT_CHANGED_DRAGMOVE_END = 'dragend.system',
  SYSTEM_VIEWPORT_CHANGED_WHEEL = 'wheel.system',

  SYSTEM_GRAB_MOUSE_DOWN = 'mousedown.grab_system',
  SYSTEM_GRAB_TOUCH_START = 'touchstart.grab_system',
  SYSTEM_GRAB_MOUSE_MOVE = 'mousemove.grab_system',
  SYSTEM_GRAB_TOUCH_MOVE = 'touchmove.grab_system',
  SYSTEM_GRAB_MOUSE_UP = 'mouseup.grab_system',
  SYSTEM_GRAB_TOUCH_END = 'touchend.grab_system',

  SYSTEM_SELECTION_MOUSE_DOWN = 'mousedown.selection_system',
  SYSTEM_SELECTION_TOUCH_START = 'touchstart.selection_system',

  SYSTEM_SELECTION_MOUSE_MOVE = 'mousemove.selection_system',
  SYSTEM_SELECTION_TOUCH_MOVE = 'touchmove.selection_system',

  SYSTEM_SELECTION_MOUSE_UP = 'mouseup.selection_system',
  SYSTEM_SELECTION_TOUCH_END = 'touchend.selection_system',
  SYSTEM_SELECTION_MOUST_OUT = 'mouseout.selection_system',

  // 선택 영역 아래에 HTML 요소가 있는 경우, 움직이거나 Wheel 할 때 추적하게
  SYSTEM_SELECTION_HTML_HOOL_DRAG_MOVE = 'dragmove.selection_html_hook_system',
  SYSTEM_SELECTION_HTML_HOOL_WHEEL = 'wheel.selection_html_hook_system',

  DEFAULT_MODE_CLICK = 'click.default',
  DEFAULT_MODE_TAP = 'tap.default',
  DEFAULT_MODE_WHEEL = 'wheel.default',

  //PINCH ZOOM 이벤트

  PINCH_ZOOM_TOUCH_START = 'touchstart.pinch_zoom',
  PINCH_ZOOM_TOUCH_MOVE = 'touchmove.pinch_zoom',
  PINCH_ZOOM_TOUCH_END = 'touchend.pinch_zoom',

  //BRUSH 모드 전용
  BRUSH_MOUSE_DOWN = 'mousedown.create_brush',
  BRUSH_TOUCH_START = 'touchstart.create_brush',
  BRUSH_MOUSE_MOVE = 'mousemove.create_brush',
  BRUSH_TOUCH_MOVE = 'touchmove.create_brush',
  BRUSH_MOUSE_UP = 'mouseup.create_brush',
  BRUSH_TOUCH_END = 'touchend.create_brush',

  // BRUSH ERASER 모드 전용
  ERASER_MOUSE_DOWN = 'mousedown.eraser_brush',
  ERASER_TOUCH_START = 'touchstart.eraser_brush',
  ERASER_MOUSE_MOVE = 'mousemove.eraser_brush',
  ERASER_TOUCH_MOVE = 'touchmove.eraser_brush',
  ERASER_MOUSE_UP = 'mouseup.eraser_brush',
  ERASER_TOUCH_END = 'touchend.eraser_brush',

  //DIRECTION_DRAW 모드 전용
  DIRECTION_DRAW_MOUSE_DOWN = 'mousedown.direction_draw',
  DIRECTION_DRAW_TOUCH_START = 'touchstart.direction_draw',
  DIRECTION_DRAW_MOUSE_MOVE = 'mousemove.direction_draw',
  DIRECTION_DRAW_TOUCH_MOVE = 'touchmove.direction_draw',
  DIRECTION_DRAW_MOUSE_UP = 'mouseup.direction_draw',
  DIRECTION_DRAW_TOUCH_END = 'touchend.direction_draw',

  // DRAG 모드 전용
  CREATE_DRAG_MOUSE_DOWN = 'mousedown.create_drag',
  CREATE_DRAG_TOUCH_START = 'touchstart.create_drag',
  CREATE_DRAG_MOUSE_MOVE = 'mousemove.create_drag',
  CREATE_DRAG_TOUCH_MOVE = 'touchmove.create_drag',
  CREATE_DRAG_MOUSE_UP = 'mouseup.create_drag',
  CREATE_DRAG_TOUCH_END = 'touchend.create_drag',

  // DRAG_AND_DROP 모드 전용
  CREATE_DRAG_AND_DROP_MOUSE_DOWN = 'mousedown.create_dnd',
  CREATE_DRAG_AND_DROP_TOUCH_START = 'touchstart.create_dnd',

  CREATE_DRAG_AND_DROP_MOUSE_UP = 'mouseup.create_dnd',
  CREATE_DRAG_AND_DROP_TOUCH_END = 'touchend.create_dnd',

  CREATE_DRAG_AND_DROP_MOUSE_MOVE = 'mousemove.create_dnd',
  CREATE_DRAG_AND_DROP_TOUCH_MOVE = 'touchmove.create_dnd',

  // MOUSE_UP 모드 전용
  CREATE_MOUSE_UP_MOUSE_DOWN = 'mousedown.create_mouse_up',
  CREATE_MOUSE_UP_TOUCH_START = 'touchstart.create_mouse_up',
  CREATE_MOUSE_UP_MOUSE_MOVE = 'mousemove.create_mouse_up',
  CREATE_MOUSE_UP_TOUCH_MOVE = 'touchmove.create_mouse_up',
  CREATE_MOUSE_UP_MOUSE_UP = 'mouseup.create_mouse_up',
  CREATE_MOUSE_UP_TOUCH_END = 'touchend.create_mouse_up',
}

export enum CANVAS_ENTITY_EVENT {
  BALLOON_MOUSE_DOWN = 'mousedown.balloon',
  BALLOON_TOUCH_START = 'touchstart.balloon',
  BALLOON_MOUSE_ENTER = 'mouseenter.balloon',
  BALLOON_MOUSE_LEAVE = 'mouseleave.balloon',
  BALLOON_DRAG_START = 'dragstart.balloon',
  BALLOON_DRAG_END = 'dragend.balloon',

  //버튼그룹 관련
  BUTTON_GROUP_STAGE_SCALEX_CHANGE = 'scaleXChange.buttonGroupElement',
  BUTTON_GROUP_STAGE_SCALEY_CHANGE = 'scaleYChange.buttonGroupElement',
  BUTTON_GROUP_STAGE_DRAG_MOVE = 'dragmove.buttonGroupElement',
  BUTTON_GROUP_STAGE_WHEEL = 'wheel.buttonGroupElement',
  BUTTON_GROUP_STAGE_DRAG_END = 'dragend.buttonGroupElement',
  BUTTON_GROUP_STAGE_CLICK = 'click.buttonGroupElement',

  // Entitiy에 마우스가 들어오면 커서를 클릭가능한 커서로 변경
  ENTITY_FOCUS_MOUSE_ENTER = 'mouseenter.entity',
  ENTITY_FOCUS_MOUSE_LEAVE = 'mouseleave.entity',

  ENTITIY_FOCUS_MOUSE_DOWN = 'mousedown.entity',
  ENTITIY_FOCUS_TOUCH_START = 'touchstart.entity',

  ENTITY_DRAG_START = 'dragstart.entity',
  ENTITY_DRAG_END = 'dragend.entity',

  SELECT_MOUSE_UP = 'mouseup.selectShape',
  SELECT_TOUCH_END = 'touchend.selectShape',
  SELECT_TAP = 'tap.selectShape',
  SELECT_CLICK = 'click.selectShape',

  SELECT_DRAG_MOVE = 'dragmove.selectShape',
  SELECT_DRAG_END = 'dragend.selectShape',
  SELECT_DRAG_START = 'dragstart.selectShape',

  SELECT_TRANSFORM_END = 'transformend.selectShape',
  SELECT_TRANSFORMED = 'transform.selectShape',
  SELECT_TRANSFORM_START = 'transformstart',

  SELECT_LINE_MOUSE_UP = 'mouseup.selectLine',
  SELECT_LINE_DRAG_END = 'dragend.selectLine',

  // TRIPOD 편집 버튼 이벤트
  EDIT_BUTTON_MOUSE_ENTER = 'mouseenter.editButton',
  EDIT_BUTTON_MOUSE_LEAVE = 'mouseleave.editButton',
  EDIT_BUTTON_CLICK = 'click.editButton',
  EDIT_BUTTON_TAP = 'tap.editButton',
}

// 모든 스타일 요소의 scale 계산 기준 크기
// 구름의 호 크기, 점선의 길이와 간격, 빗금의 간격 등의 기준으로 사용
export const SCALE_BASE_SIZE = 2000

// 영역 도형 외곽선 점선의 기준 길이와 간격
export const DASH_LENGTH = 8
export const DASH_GAP = 4

// 구름도형의 호 반지름 (기존의 간격_spacing은 반지름의 2배수)
export const CLOUD_RADIUS = 8

// DIR_DRAW (방향 도형 그리기) 모드 관련 상수
export const DIR_DRAW_ARROW_SIZE = 6 // 화살표머리 크기 (strokeWidth에 의해 벌룬크기에 따라 커짐)
export const DIR_DRAW_DIRECTION_THRESHOLD = 30 // 방향성을 결정하는 임계값 (거리)
export const DIR_DRAW_MAX_BENDS = 2 // 꺾은점의 최대갯수
export const DIR_DRAW_MIN_LENGTH = 20 // 꺾은선의 최소길이
export const DIR_DRAW_BEND_ANGLE = 90 // 꺾이는 고정 각도
export const DIR_DRAW_BEND_THRESHOLD = 45 // 꺾이는 임계값 (각도차이)
export const DIR_DRAW_END_OFFSET = 3 // 화살표 끝점 보정 상수

// TRIPOD (삼발이) 화살표헤드-선 최소길이 관련 상수
export const TRIPOD_ARROW_MIN_LENGTH = 20 // 화살표헤드-선의 최소길이 (줌레벨 1 기준)
export const TRIPOD_ARROW_MIN_LENGTH_FACTOR = 1.5 // 줌레벨에 따른 최소길이 보정 계수

// 방향 그리기 돋보기 관련 상수
export const DIR_DRAW_MAGNIFYING_GLASS_THRESHOLD = 80 // 돋보기를 숨기는 임계값 (거리)
export const MAGNIFIER_RADIUS = 60 // 돋보기 원의 반지름 (px)
export const MAGNIFIER_SCALE = 2.0 // 돋보기 확대 배율
export const MAGNIFIER_BORDER_WIDTH = 3 // 돋보기 테두리 두께 (px)
export const MAGNIFIER_BORDER_COLOR = '#333333' // 돋보기 테두리 색상
export const MAGNIFIER_VIEWPORT_MARGIN = 50 // 뷰포트 경계로부터의 여백 (px)
export const MAGNIFIER_OFFSET = 50 // 포인터로부터의 기본 거리 (px)

// 화살표가 진행될 방향성들 (현재는 8방향)
export const DIRECTIONS: Vector2d[] = [
  { x: 0, y: -1 }, // 북
  { x: 0.707, y: -0.707 }, // 북동
  { x: 1, y: 0 }, // 동
  { x: 0.707, y: 0.707 }, // 동남
  { x: 0, y: 1 }, // 남
  { x: -0.707, y: 0.707 }, // 남서
  { x: -1, y: 0 }, // 서
  { x: -0.707, y: -0.707 }, // 서북
]
// DIR_DRAW (방향 도형 그리기) 모드 관련 상수

export const BALLOON_TEXT_SIZE = 20

// RECT 드래그 생성 관련 상수
export const RECT_DRAG_GUIDE_COLOR = '#FF0099' // RECT 드래그 가이드 색상
export const RECT_DRAG_GUIDE_OPACITY = 0.3 // RECT 드래그 가이드 채우기 투명도
export const RECT_DRAG_GUIDE_DASH = [8, 8] // RECT 드래그 가이드 점선 패턴
export const RECT_DRAG_MIN_DISTANCE = 5 // 클릭과 드래그를 구분하는 최소 거리 (픽셀)

// 그랩 박스 관련 상수 (그랩하기 위한 박스 + 그랩된 도형들을 감싸는 박스)
export const GRAB_BOX_MIN_DISTANCE = 3 // 박스 최소 사이즈
export const GRAB_BOX_COLOR = '#1890FF' // 박스 색상
export const GRAB_BOX_FILL_OPACITY = 0.05 // 박스 배경 투명도
export const GRAB_BOX_BORDER_WIDTH = 1 // 박스 테두리 두께

// 그랩된 도형 하이라이트 관련 상수
export const GRAB_HIGHLIGHT_COLOR = '#FF0099' // 도형 하이라이트 색상
export const GRAB_HIGHLIGHT_FILL_OPACITY = 0.1 // 도형 하이라이트 배경 투명도
export const GRAB_HIGHLIGHT_BORDER_WIDTH = 1 // 도형 하이라이트 테두리 두께
